import { Element } from 'react-scroll';
import styles from 'sections/heroPage/advantages/advantages.module.css';
import generalStyles from 'index.module.css';
import { IS_MOBILE } from 'constants/responsive';
import { useGetAdvantagesData } from 'sections/heroPage/advantages/advantages.hooks';

export const Advantages = () => {
    const advantages = useGetAdvantagesData();
    const setBorderBottom = IS_MOBILE ? `${styles.borderBottom}` : null;

    return (
        <section id="section-advantages" className={generalStyles.heightAuto}>
            <Element name="advantages" className={styles.advantages}>
                <div className={generalStyles.container}>
                    <div className={styles.advantagesListContainer}>
                        <div className={styles.advantagesList}>
                            {advantages.slice(0, 3).map(({ name, icon }) => {
                                return (
                                    <div
                                        className={`${styles.advantagesList__item} ${styles.borderBottom}`}
                                        key={name}
                                    >
                                        <div className={styles.item__icon}>
                                            {icon}
                                        </div>
                                        <p>{name}</p>
                                    </div>
                                );
                            })}
                        </div>
                        <div className={styles.advantagesList}>
                            {advantages.slice(3, 6).map(({ name, icon }) => {
                                return (
                                    <div
                                        className={`${styles.advantagesList__item} ${styles.advantagesList__second} ${setBorderBottom}`}
                                        key={name}
                                    >
                                        <div className={styles.item__icon}>
                                            {icon}
                                        </div>
                                        <p>{name}</p>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </Element>
        </section>
    );
};
